<!-- 基础页面布局，包含了头部导航，底部信息,内容部分 -->
<template>
  <div class="app-container">
    <div class="app-header-fixed">
      <div class="app-header-search">
        <div class="logo flex-align-justify-center">
          <router-link to="/">
            <div class="logo-image">
              <img src="@/assets/images/logo.png">
            </div>
          </router-link>
          <div
            class="sbrand_name"
            @click="selectSbrand"
          >
          <!-- {{ curSbrandName }} -->
        </div>
        </div>
        <div class="cut-mid"></div>
        <div class="search">
          <div class="search-content flex-align-center">
            <el-input
              class="search-input el-input--medium"
              v-model="searchValue"
              :placeholder="searchPlaceholder"
              @keyup.enter.native="search"
            >
            </el-input>
            <span
              class="search-button"
              @click="search"
            >
              <i class="el-input__icon el-icon-search"></i>
            </span>
          </div>
        </div>
        <div class="login-user">
          <div
            class="user"
            v-if="isLogin"
          >
            <div class="order">
              <i class="el-icon-document"></i>
              <span @click="toUrl('orderIndex')">我的订单</span>
            </div>
            <div class="cart">
              <router-link to="/cart">
                <i class="el-icon-goods"></i>购物车
                <span
                  id="cart-goods-number"
                  class="cart-goods-number"
                  v-if="$user.getCartCount() > 0"
                >
                  {{ $user.getCartCount() }}
                </span>
              </router-link>
            </div>
            <div class="user-login">
              <el-dropdown @command="userDropdownCommand">
                <span class="el-dropdown-link">
                  <i class="iconfont zk-wode"></i>{{ userData.user_name }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="orderIndex">我的订单</el-dropdown-item>
                  <el-dropdown-item command="userIndex">个人中心</el-dropdown-item>
                  <el-dropdown-item
                    command="logout"
                    divided
                  >退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div
            class="login"
            v-else
          >
            <div class="register">
              <router-link to="/auth/register">
                <i
                  class="iconfont zk-zhuce"
                  style="color: #80BD01;"
                ></i>
                <el-button
                  type="text"
                  style="font-size: 16px;"
                >快速注册</el-button>
              </router-link>
            </div>
            <div class="user-login">
              <router-link to="/auth/login">
                <i
                  class="iconfont zk-wode"
                  style="color: #80BD01;"
                ></i>
                <el-button
                  type="text"
                  style="font-size: 16px;"
                >用户登录</el-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 导航栏和导航菜单 -->
      <template v-if="$user.getSbrandId() =='1'">
        <navi-bar :isMenuHidden="$route.name == 'index' ? false : true"></navi-bar>
      </template>
      <template v-else>
        <navi-bar-sbrand :isMenuHidden="$route.name == 'index' ? false : true"></navi-bar-sbrand>
      </template>
    </div>
    <div class="app-header-bak"></div>
    <div class="app-wrapper">
      <section class="app-main" style="padding-top: 20px;">
        <router-view></router-view>
      </section>
    </div>
    <div class='navi-footer-bar' style="background-color: #005192;height: 5px;">
      <!-- <div class="navi-1"></div>
      <div class="navi-2"></div>
      <div class="navi-3"></div> -->
    </div>
    <div class="flex flex-column app-footer">
      <!-- <div class="footer-link">
        <el-col
          :xs="2"
          :sm="2"
          :md="2"
          :lg="2"
          :xl="2"
        >
          <router-link to="/">
            <div class="logo">
              <div class="logo-image"><img src="../../assets/images/logo.png"></div>
            </div>
          </router-link>
        </el-col>
        <el-col
          :xs="18"
          :sm="18"
          :md="20"
          :lg="20"
          :xl="20"
        >
          <div class="link">
            <span
              v-for="(item, key) in linkList"
              :key="key"
            >
              <i v-if="key > 0"> | </i>
              <router-link
                :to="item.path"
                target="_blank"
              >{{ item.name }}</router-link>
            </span>
          </div>
        </el-col>
        <el-col
          :xs="4"
          :sm="4"
          :md="2"
          :lg="2"
          :xl="2"
        >
          <div
            class="kefu"
            @click.stop="showContactCustomerServiceDialog"
          >
            <el-button
              type="primary"
              icon="el-icon-service"
              round
            >咨询客服</el-button>
          </div>
        </el-col>
      </div> -->
      <div class="footer-copyright">
        <el-row :gutter="10">
          <el-col
            :xs="24"
            :sm="6"
            :md="8"
            :lg="8"
            :xl="8"
            class="copyright-col"
          >
            <div class="copyright">{{ siteSettingData.system_site_copyright }}</div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="10"
            :lg="10"
            :xl="10"
          >
            <div
              class="address"
              v-html="siteSettingData.system_site_address"
            ></div>
          </el-col>
          <el-col
            :xs="24"
            :sm="6"
            :md="6"
            :lg="6"
            :xl="6"
          >
            <div class="beian">{{ siteSettingData.system_site_beian }}</div>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-backtop
      v-if="$route.meta.showPPT"
      class="right-fixed-view"
      :right="120"
      :visibility-height="100"
      :bottom="400"
    >
      <div class="right-location">
        <!-- <div
          class="item download-ppt"
          @click.stop="downloadPPT"
        >
          <i class="iconfont zk-wenjian_ppt ppt"></i>
          <span class="title">下载PPT</span>
          <span
            class="ppt-count"
            v-if="$user.getPptCount() > 0"
          >{{ $user.getPptCount() }}</span>
        </div> -->
        <!-- <div
          class="item customer-service"
          @click.stop="showContactCustomerServiceDialog"
        >
          <i class="iconfont zk-kefu service"></i>
          <span class="title">联系客服</span>
        </div> -->
        <div class="item back-top">
          <i class="iconfont zk-backtop backtop"></i>
          <span class="title">返回顶部</span>
        </div>
      </div>
    </el-backtop>
    <connect-people
      :visible="contactCustomerServiceDialogData.visible"
      @close="contactCustomerServiceDialogData.visible=false"
    >
    </connect-people>
    <select-sbrand
      :showDialogClose="selectSbrandDialogData.showDialogClose"
      :visible="selectSbrandDialogData.visible"
      :sbrandList="selectSbrandDialogData.sbrandList"
      @refreshSbrand="refreshSbrand"
      @refreshSbrandSuccess="refreshSbrandSuccess"
      @close="selectSbrandDialogDataClose"
    >
    </select-sbrand>
  </div>
</template>

<script>
//  获得，登录状态下不能访问的列表；未登录状态不能访问的列表
import { loginAllowList } from '@/config/router.config';
import NaviBar from '@/views/layouts/NaviBar.vue';
import NaviBarSbrand from '@/views/layouts/NaviBarSbrand.vue';
import ConnectPeople from "../../components/ConnectPeopleDialog/ConnectPeople.vue";
import SelectSbrand from '@/components/SelectSbrandDialog/SelectSbrand.vue';

export default {
  name: 'BasicLayout',
  components: {
    ConnectPeople,
    NaviBar,
    NaviBarSbrand,
    SelectSbrand,
  },
  data() {
    return {
      curSbrandName: '',
      siteSettingData: {
        "system_site_name": "",
        "system_site_english_name": "",
        "system_site_title": "",
        "system_site_keyword": "",
        "system_site_desc": "",
        "system_site_copyright": "",
        "system_site_phone": "",
        "system_site_address": "",
        "system_site_beian": "",
      },     //  站点设置
      searchPlaceholder: '您想要的在这里，搜搜看',    //  搜索默认显示
      menuHidden: false,   //  竖行导航栏是否隐藏
      searchValue: '',    //  搜索内容
      isLogin: false,     //  是否登录
      userData: {},       //	用户数据
      linkList: [
        {
          'name': '关于我们',
          'path': '/about',
        },
        {
          'name': '服务条款',
          'path': '/service',
        },
        {
          'name': '隐私政策',
          'path': '/privacy',
        },
        {
          'name': '购物指南',
          'path': '/guide',
        },
        {
          'name': '定制说明',
          'path': '/order-process',
        },
        {
          'name': '常见问题',
          'path': '/question',
        },
      ],
      contactCustomerServiceDialogData: {          //  发票弹框配置
        visible: false,
        title: '',
      },
      selectSbrandDialogData: {   //  选择服务商户弹框配置
        visible: false,
        showDialogClose: true,
        sbrandList: [],
      },
    };
  },
  mounted() {
    if (this.$user.checkLogin()) {
      this.isLogin = true;
      let userData = this.$user.getLoginUserLocalStorage();
      if (userData) {
        this.userData = userData;
        this.curSbrandName = userData.user_sbrand_data && userData.user_sbrand_data.sbrand_name;
        if (this.$route.query.admin_select_sbrand_id && this.$route.query.admin_select_sbrand_id != userData.user_sbrand_id) {
          this.selectSbrand()
        }
      } else {
        this.$user.getLoginUserData({
          success: (result) => {
            if (result) {
              this.userData = result;
              if (this.$route.query.admin_select_sbrand_id && this.$route.query.admin_select_sbrand_id != userData.user_sbrand_id) {
                this.selectSbrand()
              }
            }
          },
        });
      }
    } else {
      this.curSbrandName = '米其林商城';
    }

    //  搜索页面
    if (this.$route.name == 'search') {
      let searchValue = this.$route.query.content;
      if (!this.$util.isEmpty(searchValue)) {
        this.searchValue = searchValue;
      }
    }
    this.siteSetting();     //  站点设置

    $('html,body').animate({
      scrollTop: "1px"
    }, 300);
  },

  methods: {
    /**
     * 站点设置
     */
    siteSetting() {
      this.$http.post('/public/site-setting').then(res => {
        if (res.ret == '0') {
          let siteSettingData = res.data;
          siteSettingData.system_site_address = siteSettingData.system_site_address.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
          this.siteSettingData = siteSettingData;
        }
      });
    },
    /**
     * 页面跳转
     * @param {*} path 
     */
    toUrl(name) {
      if (this.$route.name !== name) {
        this.$router.push({
          name: name
        });
      }
    },
    /**
     * 点击用户下拉列表操作
     * @param {*} command 
     */
    userDropdownCommand(command) {
      if (command === 'logout') { //  登录退出
        this.$user.logout({
          success: (res) => {
            this.isLogin = false;
            this.userData = {};
            this.$message.success('用户已成功退出！');
            // setTimeout(() => {
            //   //  当前页面是在未登录下不能访问的话，需要跳到登录页面
            //   if (loginAllowList.includes(this.$route.name)) {
            //     this.$router.push('/auth/login');
            //   }
            // }, 1500);
            this.$router.push('/auth/login');
          },
        });
      } else {
        this.toUrl(command);
      }
    },
    /**
     * 点击搜索按钮函数
     */
    search() {
      let url = '/search';
      if (!this.$util.isEmpty(this.searchValue)) {
        url += '?content=' + this.searchValue;
      }
      window.location.href = url;
    },

    /**
     * 下载PPT
     */
    downloadPPT() {
      let route = this.$router.resolve({ path: '/ppt' });
      window.open(route.href, '_blank');
      // this.$user.downLoadPPTOrPDF();
    },

    /**
     * 联系客服
     */
    showContactCustomerServiceDialog() {
      this.contactCustomerServiceDialogData.visible = true;
    },

    /**
     * 选择服务品牌商户
     */
    selectSbrand() {
      this.$http.post('/user/get-sbrand-list', {}, {
        custom: {
          auth: true,
          loading: true,
        }
      }).then(result => {
        if (result.ret == '0') {
          if (result.data.length > 1) {
            this.selectSbrandDialogData.visible = true;
            this.selectSbrandDialogData.sbrandList = result.data;
          }
        }
      });
    },
    /**
     * 刷新服务商户
     */
    refreshSbrand() {
      this.$user.init();  //	初始化用户数据
      this.selectSbrandDialogDataClose();
    },

    /**
     * 选择服务商户后刷新数据
     */
    refreshSbrandSuccess() {
      let userData = this.$user.getLoginUserLocalStorage();
      if (userData) {
        this.userData = userData;
        this.curSbrandName = userData.user_sbrand_data && userData.user_sbrand_data.sbrand_name;
      }
      this.$router.push({ path: '/' });   //  返回首页
      this.$nextTick(() => {
        location.reload();
      })
    },

    /**
     * 关闭选择服务商户对话框
     */
    selectSbrandDialogDataClose() {
      this.selectSbrandDialogData.visible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  font-family: "思源黑体" !important;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  height: 100%;
  width: 100%;

  .app-header-fixed {
    width: 100%;
    height: 150px;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #fff;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.03);
    z-index: 99;
  }

  .app-header-bak {
    height: 150px;
  }

  .app-header-search {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 74%;
    @media screen and (max-width: 1300px) {
      width: 96%;
    }
    margin: 0 auto;
    padding: 16px 0px;
    .logo {
      flex: 2;
      @media screen and (max-width: 1300px) {
        flex: 0 0 2;
      }
      .logo-image {
        text-align: center;

        > img {
          height: 60px;
        }
      }

      .logo-image:hover {
        cursor: pointer;
      }

      .sbrand_name {
        font-size: 18px;
        font-weight: bold;
        padding-left: 18px;
        color: #606266;
        cursor: pointer;
      }
    }
    .cut-mid {
      // flex: 1;
      @media screen and (max-width: 1300px) {
        flex: 0 0 10px;
      }
    }

    .search {
      flex: 3;

      .search-content {
        position: relative;

        .search-input {
          ::v-deep(.el-input__inner) {
            border-radius: 50px;
            border: #dcdcdc solid 1px;
          }

          // .el-input__suffix {
          //     right: 0px;
          // }
        }

        .el-icon-search {
          border-radius: 50px;
          background-color: #80bd01;
          width: 40px;
          color: #ffffff;
        }

        .search-button {
          position: absolute;
          right: 0;
          cursor: pointer;
        }
      }
    }

    .login-user {
      flex: 3;
      font-size: 16px;

      i {
        padding-right: 5px;
      }

      .el-dropdown-link {
        cursor: pointer;
        font-size: 16px;
      }

      .login {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;

        .user-login {
          padding-right: 3%;
        }

        .register {
          padding-right: 10%;
        }
      }

      .user {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;

        .user-login {
          padding-right: 3%;

          ::v-deep(.el-dropdown) {
            color: #000000;
          }
        }
        .order {
          font-size: 16px;
          cursor: pointer;
          padding-right: 11%;
          min-width: 100px;
        }

        .cart {
          cursor: pointer;
          min-width: 120px;

          .cart-goods-number {
            border-radius: 20px;
            display: inline-block;
            font-size: 12px;
            margin-right: 24px;
            height: 20px;
            line-height: 20px;
            width: 20px;
            text-align: center;
            background-color: #80bd01;
            color: #ffffff;
          }
        }
      }

      // border: #00C250 solid 1px;
    }
  }

  // .main-container {}

  // .app-wrapper {}

  .app-footer {
    max-width: 1300px;
    width: 80%;
    margin: 0 auto;
    padding: 28px 0px;

    .footer-link {
      width: 100%;
      padding-bottom: 40px;
      display: flex;
      justify-items: center;
      align-items: center;

      .logo {
        text-align: center;

        .logo-image {
          width: 100%;

          img {
            width: 100%;
          }
        }

        .logo-image:hover {
          cursor: pointer;
        }
      }

      .link {
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          min-width: 70px;
          i {
            padding: 0px 40px;
            font-style: normal;
          }
        }
      }

      .kefu {
        text-align: right;
        // padding-right: 14%;
        display: flex;
        flex-direction: row-reverse;
      }
    }

    .footer-copyright {
      .el-row {
        margin: 0px !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        font-size: 14px;
      }

      .copyright-col {
        padding-left: 0px !important;
        padding-right: 0px !important;
      }

      // .copyright {}

      // .address {}

      .beian {
        text-align: right;
        // padding-right: 10%;
      }
    }
  }

  .navi-footer-bar {
    position: relative;
    height: 16px;
    background-color: #f8cf3c;
    display: flex;

    .navi-1 {
      width: 13%;
      background-color: #009a78;
    }

    .navi-2 {
      flex: 3;
      margin-left: -10px;
      background-color: #80bd01;
      clip-path: polygon(0 0%, 100% 0%, 98% 100%, 10px 100%);
    }

    .navi-3 {
      flex: 6;
      background-color: #f8cf3c;
    }
  }

  .right-fixed-view {
    width: 0px;
    height: 0px;
  }

  .right-location {
    // width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .item {
      // width: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #797979;
      color: #ffffff;
      border-radius: 5px;
      padding: 10px;
      width: 50px;
      margin-bottom: 10px;
    }

    .title {
      padding-top: 5px;
      font-size: 12px;
    }

    .download-ppt {
      background-color: #eb7923;
      position: relative;

      .ppt {
        font-size: 36px;
      }

      .ppt-count {
        position: absolute;
        top: -8px;
        right: -8px;
        border-radius: 20px;
        font-size: 12px;
        line-height: 20px;
        width: 20px;
        text-align: center;
        background-color: #80bd01;
        color: #ffffff;
      }
    }

    .customer-service {
      .service {
        font-size: 30px;
      }
    }

    .back-top {
      .backtop {
        font-size: 30px;
      }
    }
  }
}

.contact-customer-service-wrapper {
  ::v-deep(.el-dialog__header) {
    padding: 0px;
  }

  ::v-deep(.el-dialog__body) {
    padding: 20px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 20px;
    .qrcode-head {
      font-size: 20px;
      font-weight: bold;
      color: #000000;
    }
    .qrcode-desc {
      padding: 15px 0px 30px;
    }
    .qrcode-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 80%;
      .title {
        background: linear-gradient(-45deg, transparent 20px, #80bd01 0);
        width: 30%;
        color: #ffffff;
        padding: 5px 10px;
        margin-bottom: 20px;
      }
      .img {
        border: 1px solid rgb(247, 247, 247);
      }
    }
    .img {
      width: 100%;
    }

    .desc {
      padding: 10px;
      color: #80bd01;
    }
  }
}

@media screen and (max-width: 800px) {
  .footer-link {
    .link {
      span {
        i {
          padding: 0px 4px !important;
          font-style: normal;
        }
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .right-fixed-view {
    right: 50px !important;
  }
  .footer-link {
    .link {
      span {
        i {
          padding: 0px 10px !important;
          font-style: normal;
        }
      }
    }
  }
}

@media screen and (min-width: 1600px) {
  .right-fixed-view {
    right: 80px !important;
  }
  .footer-link {
    .link {
      span {
        i {
          padding: 0px 40px !important;
          font-style: normal;
        }
      }
    }
  }
}

@media screen and (min-width: 1800px) {
  .right-fixed-view {
    right: 120px !important;
  }
}
</style>
<style>
.app-container
  .app-header-search
  .search
  .search-content
  .search-input
  .el-icon-search {
  cursor: pointer;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f2f8e5 !important;
  color: #80bd01 !important;
}
</style>
